import { Injectable, EventEmitter } from "@angular/core";
import { Observable, Subscription, timer } from "rxjs";
import { debounce } from "rxjs/operators";
import { windowHeightUntilChanged } from "./get-window-height-until-changed";

export interface FramePostPayload {
    action: "RESIZE" | "RESET";
    height: number;
}

@Injectable({
    providedIn: "root",
})
export class FrameService {
    public static MIN_HEIGHT = 100;

    public resize = new EventEmitter<any>();
    public reset = new EventEmitter<any>();
    public posted = new EventEmitter<FramePostPayload>();

    private onResize$ = this.resize.pipe(
        debounce(() => timer(100)),
        windowHeightUntilChanged()
    );
    private onReset$ = this.reset.pipe(
        debounce(() => timer(100)),
        windowHeightUntilChanged()
    );

    private onResize$Sub = this.onResize$.subscribe(this.postResize.bind(this));
    private onReset$Sub = this.onReset$.subscribe(this.postReset.bind(this));

    private get isInIframe() {
        return parent !== window;
    }

    private get parentUrl() {
        let parentUrl = null;

        if (this.isInIframe) {
            parentUrl = document.referrer;
        }

        if (typeof parentUrl === "string") {
            return parentUrl
                .split("/")
                .slice(0, 3)
                .filter(Boolean)
                .join("//");
        }
    }

    private get target() {
        if (this.isInIframe) {
            return window.parent;
        } else {
            return window;
        }
    }

    private postResize(height: number) {
        if (height > FrameService.MIN_HEIGHT) {
            const payload: FramePostPayload = { action: "RESIZE", height };
            this.post(payload);
            this.posted.emit(payload);
        }
    }

    private postReset(height: number) {
        if (height > FrameService.MIN_HEIGHT) {
            const payload: FramePostPayload = { action: "RESET", height };
            this.post(payload);
            this.posted.emit(payload);
        }
    }

    private serialize(payload: FramePostPayload): string {
        return JSON.stringify(payload);
    }

    private deserialize(payload: string): FramePostPayload {
        return JSON.parse(payload);
    }

    private post(payload: FramePostPayload) {
        const parentUrl = this.parentUrl;
        const serializedPayload = this.serialize(payload);

        console.log("FrameService#post()", {
            payload,
            parentUrl,
            serializedPayload,
        });

        if (parentUrl) {
            window.parent.postMessage(serializedPayload, parentUrl);
        }
    }
}
